import { Badge } from "@mantine/core";

export default function CustomBadge({ ...props }) {
  return <Badge {...props} />;
}
